import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, ArrowUpRight, Facebook, Instagram, Linkedin } from "lucide-react";
import { SITE, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-[#0B162C] text-white/80" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img src={SITE.logo} alt="SkyRise" className="h-14 w-auto"/>
              <div className="leading-tight">
                <div className="font-serif-display text-white text-2xl">SkyRise</div>
                <div className="text-[10px] uppercase tracking-[0.24em] text-[#C5A059]">Estate & Construction Pvt. Ltd.</div>
              </div>
            </div>
            <p className="mt-6 text-white/70 leading-relaxed max-w-sm">
              Vastu-first builders, developers, project managers and real-estate specialists — delivering residential, commercial, industrial and infrastructure projects across India.
            </p>
            <div className="mt-6 text-[11px] uppercase tracking-[0.24em] text-white/50 space-y-1" data-testid="footer-cin">
              <div>CIN: {SITE.cin}</div>
              <div>Reg No: {SITE.regNo}</div>
            </div>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" aria-label="Facebook" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors" data-testid="footer-social-facebook"><Facebook size={16}/></a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors" data-testid="footer-social-instagram"><Instagram size={16}/></a>
              <a href="#" aria-label="LinkedIn" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors" data-testid="footer-social-linkedin"><Linkedin size={16}/></a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow mb-5">Explore</div>
            <ul className="space-y-3 text-[15px]">
              <li><Link to="/" className="hover:text-[#C5A059] transition-colors" data-testid="footer-nav-home">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#C5A059] transition-colors" data-testid="footer-nav-about">About Us</Link></li>
              <li><Link to="/services" className="hover:text-[#C5A059] transition-colors" data-testid="footer-nav-services">Services</Link></li>
              <li><Link to="/projects" className="hover:text-[#C5A059] transition-colors" data-testid="footer-nav-projects">Projects</Link></li>
              <li><Link to="/contact" className="hover:text-[#C5A059] transition-colors" data-testid="footer-nav-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Services</div>
            <ul className="space-y-3 text-[15px]">
              {SERVICES.map(s => (
                <li key={s.id}>
                  <Link to={`/services#${s.id}`} className="hover:text-[#C5A059] transition-colors flex items-start gap-1" data-testid={`footer-service-${s.id}`}>
                    <span>{s.title}</span>
                    <ArrowUpRight size={14} className="mt-1 opacity-60"/>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Reach Us</div>
            <ul className="space-y-4 text-[15px]">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#C5A059] mt-1"/>
                <div className="flex flex-col">
                  <a href={SITE.telHref} className="hover:text-[#C5A059] transition-colors" data-testid="footer-phone">{SITE.phone}</a>
                  <a href={SITE.tel2Href} className="hover:text-[#C5A059] transition-colors" data-testid="footer-phone-2">{SITE.phone2}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle size={16} className="text-[#C5A059] mt-1"/>
                <a href={SITE.whatsappHref} target="_blank" rel="noreferrer" className="hover:text-[#C5A059] transition-colors" data-testid="footer-whatsapp">WhatsApp Chat</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#C5A059] mt-1"/>
                <a href={`mailto:${SITE.email}`} className="hover:text-[#C5A059] transition-colors" data-testid="footer-email">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C5A059] mt-1"/>
                <span className="text-white/70" data-testid="footer-address">{SITE.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <span>© {new Date().getFullYear()} {SITE.legalName}. All rights reserved.</span>
          <span className="tracking-widest uppercase">skyriseestate.in — Stability × Prosperity × Vastu</span>
        </div>
      </div>
    </footer>
  );
}
